export function scoreCRAFFT(answers) {
  return Object.values(answers || {}).reduce(
    (total, answer) => total + (answer.valueDecimal || 0), 0)
}